

























import { Component, Vue, Mixins } from 'vue-property-decorator'; // 반드시 Vue를 vue-property-decorator에 있는 것을 써야함
import VueHoduCommon from '@/mixin/VueHoduCommon';
import WareHeader from '@/components/WareHeader.vue';
import WareFooter from '@/components/WareFooter.vue';

import { namespace } from 'vuex-class';
const WareInfo = namespace('WareInfo');

@Component({
    components: {
        WareHeader, WareFooter
    },
})
export default class App extends Mixins(VueHoduCommon) {
    
    /**
     * @WareInfo.Action
     */
    @WareInfo.Action doSetShowVoucherModal ?: (params : boolean) => void;
    
    close_voucher : boolean = false;

    beforeMount() {
        if( !(location.host.indexOf('localhost') == 0 || location.host.indexOf('dev') == 0 || new RegExp(/[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}/).test(location.host) ) ) {

            if( location.host.includes("hodu.app") ) {
                return;
            }

            location.href = 'https://hodu.app';
        }
    }

    mounted() {
        if( localStorage != null ) {
            const today = new Date();
            const today_key = `${today.getFullYear()}${`0${today.getMonth() + 1}`.slice(-2)}${`0${today.getDate()}`.slice(-2)}`;

            // 바우처 팝업 (2020-11-23 종료)
            // const save_key = localStorage.getItem('voucher_not_view_today');
            // if( this.doSetShowVoucherModal && (save_key == null || Number(save_key) < Number(today_key)) ) this.doSetShowVoucherModal(true);
        }
    }

    goVoucher() : void {
        window.open("/voucher.html", "_blank");
    }

}
